export default __webpack_public_path__ + "static/media/livestockDairy.17b3bea2.svg";